module.exports = __webpack_public_path__ + "files/a82ffb7d69f509e29239eb879ccae1bc.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/Source-Sans-Pro-regular.svg
 ** module id = 876
 ** module chunks = 0
 **/